import { Box } from '@mui/material'
import { SxProps, Theme } from '@mui/material/styles'

/**
 * The faint concentric-ring / crosshair line-art layered behind the hero and
 * CTA sections. Positioned by the `sx` passed from the section; color comes
 * from `color`, opacity from `opacity`.
 */
const RingDecoration = ({
  size,
  color,
  opacity,
  innerR = 32,
  strokeWidth = 0.7,
  sx,
}: {
  size: number
  color: string
  opacity: number
  innerR?: number
  strokeWidth?: number
  sx?: SxProps<Theme>
}) => (
  <Box
    component="svg"
    width={size}
    height={size}
    viewBox="0 0 100 100"
    fill="none"
    aria-hidden
    sx={{ position: 'absolute', color, opacity, pointerEvents: 'none', ...sx }}
  >
    <circle cx="50" cy="50" r="46" stroke="currentColor" strokeWidth={strokeWidth} />
    <circle cx="50" cy="50" r={innerR} stroke="currentColor" strokeWidth={strokeWidth} />
    <line x1="50" y1="0" x2="50" y2="100" stroke="currentColor" strokeWidth={strokeWidth} />
    <line x1="0" y1="50" x2="100" y2="50" stroke="currentColor" strokeWidth={strokeWidth} />
  </Box>
)

export default RingDecoration
